import { render, staticRenderFns } from "./ClientsRequests.vue?vue&type=template&id=110741ca&"
import script from "./ClientsRequests.vue?vue&type=script&lang=js&"
export * from "./ClientsRequests.vue?vue&type=script&lang=js&"
import style0 from "./ClientsRequests.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports